import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/ui/Button';
import StudentSignupForm from './components/StudentSignupForm';
import { registerStudent } from '../../services/registerService';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/authContext';
import { toast } from 'sonner';
import AlertBox from '../../components/ui/AlertBox';

function StudentSignupPage() {
  let navigate = useNavigate();
  let { register, handleSubmit, watch, setError, formState: { errors, isSubmitting } } = useForm();
  const { user, setUser, setProfile } = useAuth();
  const [pageError, setPageError] = useState('')

  const onSubmit = async (data) => {
    try {
      // Build dataToSend just like in LecturerSignupPage
      let dataToSend = {
        ...(data.university !== 'other' ? { university: data.university } : {}),
        ...(data?.other_university ? { other_university: data.other_university } : {}),
        ...(data.department !== 'other' ? { department: data.department } : {}),
        ...(data?.other_department ? { other_department: data.other_department } : {}),
        mat_no: data.mat_no,
      };

      console.log(dataToSend)

      const response = await registerStudent(dataToSend);

      console.log('Registration successful:', response);

      setUser(response.user);
      setProfile(response);

      toast.success('Successfully Completed your profile');
      navigate('/profile');
    } catch (error) {
      console.error('Registration failed:', error);
      Object.keys(error).forEach((field) => {
        if (field === 'non_field_errors') {
          setPageError(error[field][0]);
        } else if (field === 'user') {
          Object.keys(error.user).forEach((userField) => {
            setError(userField, { type: 'server', message: error.user[userField][0] });
          })
        } else {
          setError(field, { type: 'server', message: error[field][0] });
        }
      });
    }
  };


  return (
    <div className='bg-base-200 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-2xl mx-auto'>
        <div className="text-center space-y-4 mb-8">
          <div className="flex items-center justify-center gap-2 text-xl font-medium">
            <span>Hey,</span>
            <span className="font-bold">{user.first_name}</span>
            <span className="animate-wave text-3xl">👋</span>
          </div>

          <h1 className="text-4xl font-extrabold tracking-tight">
            Complete Your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-pink-500 to-orange-500">
              Student
            </span>{" "}
            Profile
          </h1>
        </div>
        <div className="bg-base-100 shadow-xl rounded-box p-8">
          <form onSubmit={handleSubmit(onSubmit)}>
            <AlertBox message={pageError} type='error' />
            <div className="grid grid-cols-1 gap-6">
              <StudentSignupForm
                errors={errors}
                register={register}
                watch={watch}
              />
            </div>
            <Button
              className='w-full mt-4'
              isLoading={isSubmitting}
            >
              Create Account
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default StudentSignupPage